import React, { useState, useEffect, useContext } from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import * as net from "../../../lib/net";
import Fr_Input from "../../../lib/ui/fr_input";
import Fr_Select from "../../../lib/ui/fr_select";
import * as utils from "../../../assets/utils";

class Preg_Fill extends React.Component {
  constructor(props, context) {
    super(props);

    this.pos = props.store.pos;
    this.state = {};
    this.state.mka = [];
    this.state.sval = [];
    this.state.tval = [];
    this.state.paa = [];
    this.state.uaa = [];
    this.state.laa = [];

    this.state.sz_val = "";
      this.state.gnr = "001";
    //this.state.lro = props.lro;
    this.state.ynq = [
                {id: '0', text: 'NEJ'},
                {id: '1', text: 'JA'}
            ];

            this.state.cols = {};
            this.state.wnds = {};
            this.state.pro = {};
    this.state.refill = "";

    if(props.wnds.pro) {
        this.state.pro = props.wnds.pro;
    }
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      if(!this.props.wnds.pro) this.preg_init();
  }

    preg_init() {
        var udo = {};
        udo.e1bastyp = "";
        udo.e1typ = "";
        udo.e1blank = "";
        udo.e1kontonr = "";
        udo.e1text = "";
        udo.e1debcre = "";
        udo.e1moms = "";
        udo.e1pris = "";
        udo.e1mattyp = "";
        udo.e1kassabal = "";
        udo.e1cancelled = "";
        udo.e1paytrans = "";
        udo.e1man_rep = "";
        udo.e1no_avail = "";
        //alert(JSON.stringify(rso));
        this.setState({ udo: udo });
        return;
    }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }

    formchange (e) {
      const name = e.target.name;
      const value = e.target.value;
      var pbo = this.state.pbo;
      var na = name.split(".");
      pbo[na[0]][na[1]] = value;
      this.setState({pbo: pbo});
      //setState({[name]: value});
    }

    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({user: user});
      //setState({[name]: value});
    }
    wnd_close = () => {
      if(this.props.close) {
          this.props.close(this.props.ctx);
      }
      else this.props.ctx.setState({ wnds: {} });
	};
    handleChange = (event, newValue) => {
        //alert(newValue);
        this.setState({ix: newValue});
      };
    toggle() {
      this.setState({modal: false});
	};

  submitHandler = event => {
    event.preventDefault();
    event.target.className += " was-validated";
  };

  changeHandler = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

    val_save(id, val) {
        var pro = this.state.pro;
        var f0 = id.split(".")[0];
        var f1 = id.split(".")[1];
        pro[f0][f1] = val;
        this.setState({ pro: pro });
        return;
    }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }
  cssCols (cid) {
      var css = {};
      if(this.state.cols[cid]) css.width = this.state.cols[cid].toString() + "px";
      //if(cid == "c01") alert(JSON.stringify(this.state.cols[cid]));
      return css;
  }
  pres_save() {
    var self = this;
    var prm = {};
    prm.req = "crs.crs_reg.pres_upd";
    prm.pro = this.state.pro;
    //prm.sid = "S0001611";

    //net.sid_req(prm)
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));
        if(ret.ok == "000") {
            self.setState({wnd_ok: true });
            setTimeout(function(){
                self.setState({wnd_ok: false });
                  if(self.props.wnds.cb) {
                      self.props.wnds.cb(self.props.ctx);
                  }
                  else self.props.ctx.setState({ wnds: {} });
                return;
            }, 1000);
        }
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
  pres_del() {
    var self = this;
    var prm = {};
    prm.req = "crs.crs_reg.pres_del";
    prm.pro = this.state.pro;
    //prm.sid = "S0001611";

    //net.sid_req(prm)
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));
        if(ret.ok == "000") {
            self.setState({wnd_ok: true });
            setTimeout(function(){
                self.setState({wnd_ok: false });
                  if(self.props.close) {
                      self.props.close(self.props.ctx);
                  }
                  else self.props.ctx.setState({ wnd_rs: false });
                return;
            }, 1000);
        }
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
    pres_fill() {
        var self = this;

        var saldo = this.state.refill;
        if(saldo.includes(".")) saldo = saldo.replace(/\./g,"");
        else saldo = saldo + "00";
  
        var prm = {};
        prm.req = "crs.crs_reg.pres_fill";
        prm.pro = this.state.pro;
        prm.belopp = saldo;
        //prm.sid = "S0001611";

        //net.sid_req(prm)
        net.sio_req(prm)
           .then(function(ret){
                //alert(JSON.stringify(ret));
                if(ret.ok == "000") {
                    self.setState({wnd_ok: true });
                    setTimeout(function(){
                        self.setState({wnd_ok: false });
                        if(self.props.wnds.cb) {
                            var rsp = {};
                            rsp.ok = "000";
                            rsp.saldo = saldo;
                            self.props.wnds.cb(self.props.ctx, rsp);
                        }
                        else self.props.ctx.setState({ wnds: {} });
                        return;
                    }, 100);
                }
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }
    sz_keydown (e) {
        //e.preventDefault();
        const key = e.key;
        const keyCode = e.keyCode;

        if(keyCode == 13) {
            this.plu_sz();
        };
        if(keyCode == 27) {
            this.setState({sz_val: ""});
        };
    }
    sz_change (e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({sz_val: value});
        //setState({[name]: value});
    }

  render() {
    //if(!this.props.show) return "";
    var title = this.props.title;
    if(!title) title = "UDID";
    //if(props.kro) alert(props.kro.krr00.kid);

	var html =
        <div className="mx_base">
        <div className="m2_backdrop" />
        <div className="m2_dlg mx_50 flex-col" style={ this.dlg_style() } >
        <div className="mx_top flex-row">

            <div className="txt-22">
                <div>FYLL PRESENTKORT: { utils.toNum( this.state.pro.pres00.p0id ) }</div>
            </div>
            <div className="flex"></div>
            <div>UPPDATERA</div>
        </div>
            <div className="divider_orange"></div>

            <form className="cdi_f03">
                <div className="flex-row">
                    <Fr_Input label="Text" className="text-left w350" text={ this.state.pro.pres00.p0text } getValue={(e)=> this.val_save("e1text", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Saldo att sätta" className="text-left w250" text={ this.state.refill } getValue={(val) => this.setState({"refill": val}) } />
                </div>
            </form>

            <div className="flex"></div>

        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <div className="flex-row">
            <button className="btn btn-hw-green w250" onClick={() => this.pres_fill() } >
                FYLL PÅ
            </button>
            </div>
        </div>
      </div>

      </div>
	;
	return html;
  };
}

export default Preg_Fill;